import React, { useEffect, useRef, useState } from 'react';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { RootState } from '../reducers';
import { useDispatch, useSelector } from 'react-redux';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';
import { LoginService } from '../services/LoginService';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { useNavigate } from 'react-router-dom';
import { fetchACDData, fetchCSData } from '../reduxactions/patientactions/PatientReportsActions';
// import {fetchACDData,fetchCSData} from '../reduxactions/patientactions/PatientReportsActions';
// import {fetchACDData,fetchCSData } from '../reduxactions/patientactions/PatientReportsActions'

interface SharedFileProps {
  item: ItemType; // Replace ItemType with the actual type of item
  furl: any;
  sanitizer: SanitizerType; // Replace SanitizerType with the actual type of sanitizer
}

interface ItemType {
  eventid: number;
  videotype: string;
}

interface SanitizerType { }

export const PatientReports = () => {
  const uid = window.sessionStorage.getItem('uid');
  const [activeIndex, setActiveIndex] = useState(0);
  const [globalFilter, setGlobalFilter] = useState('');
  const stepperRef = useRef(null);


  const dispatch = useDispatch();
  const casesss = useSelector((state: RootState) => state.patientreports.cases);
  const accountss = useSelector((state: RootState) => state.patientreports.accountdetails);



  const fetchDataAsync1 = async () => {
    try {
      await dispatch(fetchCSData(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchDataAsync2 = async () => {
    try {
      await dispatch(fetchACDData(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchDataAsync2();
    fetchDataAsync1();
  }, [dispatch]);
  const navigate = useNavigate();
  const viewPage = (rowData: any) => {
    const url = `/viewpatreports/${rowData.CaseID}`;
    console.log('rowdata:', rowData.CaseID)
    navigate(url);
  };
  const ViewPrint = (rowData: any) => {
        const url = `/patientinvoice/${rowData.transaction_id}`;
        console.log('rowdata:', rowData.caseid)
        navigate(url);
    }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/patientreports.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="main-content">
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="grid mb-2">
              <div className="col-9">
                <h2>Patient Reports</h2>
              </div>
              <div className="col-3">
                <a
                  title="help"
                  onClick={(e) => openWindow(e, IUrl)}
                  style={{

                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                  <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                </a>
              </div>

            </div>
          </div>
        </section>
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card-header p-2"></div>
              <div className="box box-primary">
                <div className="card">
                  <Stepper ref={stepperRef}>
                    <StepperPanel header="Cases">
                      <p className="m-0">
                        <div>
                          <div className="card flex flex-wrap justify-content">
                            <span className="p-input-icon-left">
                              <i className="pi pi-search" />
                              <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                            </span>
                          </div>
                          <div className="card">
                            <DataTable value={casesss} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                              globalFilterFields={['FirstName', 'CreateDate', 'CaseStatus', 'Status']}>
                              <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                              <Column header="Doctor Name" body={(rowData) => `${rowData.FirstName}`} />
                              <Column field="CreateDate" sortable header="Created Date"></Column>
                              {/* <Column field="CaseStatus" sortable header="Status"></Column> */}
                              <Column header="Status" sortable body={(rowData) => rowData.CaseStatus ? rowData.CaseStatus.charAt(0).toUpperCase() + rowData.CaseStatus.slice(1).toLowerCase() : ''} />
                              <Column header="Option" body={(rowData) => (
                                <div className="options-buttons">
                                  <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage(rowData)} />
                                </div>
                              )}></Column>
                            </DataTable>
                          </div>
                        </div>
                      </p>
                    </StepperPanel>

                    <StepperPanel header="Account Details">
                      <p className="m-0">
                        <div>
                          <div className="card flex flex-wrap justify-content">
                            <span className="p-input-icon-left">
                              <i className="pi pi-search" />
                              <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                            </span>
                          </div>
                          <div className="card">
                            <DataTable value={accountss} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                              globalFilterFields={['FirstName', 'PaidDate', 'Amount', 'transaction_id']}>
                              <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                              <Column header="Doctor" body={(rowData) => `${rowData.FirstName}`} />
                              <Column field="Amount" sortable header="Amount"></Column>
                              <Column field="PaidDate" sortable header="Paid Date"></Column>
                              <Column field="transaction_id" sortable header="Transaction ID"></Column>
                              <Column header="Option" body={(rowData) => (
                                <div className="options-buttons">
                                  <Button icon="pi pi-print" rounded outlined tooltip="Print" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewPrint(rowData)} />
                                </div>
                              )}></Column>
                            </DataTable>
                          </div>
                        </div>
                      </p>
                    </StepperPanel>
                  </Stepper>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
